import { render, staticRenderFns } from "./PatentSearchDatabase.vue?vue&type=template&id=87167164&"
import script from "./PatentSearchDatabase.vue?vue&type=script&lang=js&"
export * from "./PatentSearchDatabase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports